import { useState } from 'react';
import { avatarColors, initials } from '../utils/format';

type AvatarSize = 'sm' | 'md' | 'lg' | 'xl';

interface AvatarProps {
  name: string;
  photoSrc?: string | null;
  size?: AvatarSize;
  className?: string;
  title?: string;
}

export function Avatar({ name, photoSrc, size = 'md', className, title }: AvatarProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const [bg, fg] = avatarColors(name);
  const showPhoto = Boolean(photoSrc) && failedSrc !== photoSrc;
  const classes = ['avatar', size === 'md' ? '' : `avatar-${size}`, className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <span className={classes} style={{ background: bg, color: fg }} title={title}>
      {showPhoto && photoSrc ? (
        <img src={photoSrc} alt="" onError={() => setFailedSrc(photoSrc)} />
      ) : (
        initials(name)
      )}
    </span>
  );
}
